import Service from '../Service';
import { addFingerprintToRequest } from './utils';
import Request from '../Request';
import { ResponseErrorBody, EditPasswordForm } from '../../types';

export default async function(params: EditPasswordForm) {
  const request = await addFingerprintToRequest(
    new Request(`/api/auth/password/change`)
      .setMethod('POST')
      .setPayload(params)
  );
  const service = new Service<any, ResponseErrorBody>(request);
  return await service.send();
}
